'use client'

import { ScheduleCallCTA } from '~/components/ScheduleCallCTA'
import { ONTRACK_CALENDLY_HREF, useOnTrackUnlocked } from './unlock-state'

export function AdvisorCallout() {
  const unlocked = useOnTrackUnlocked()

  return (
    <section
      aria-labelledby="ontrack-advisor-heading"
      className="dark mx-auto flex max-w-300 flex-col items-start gap-6 rounded-3xl bg-green-darker p-6 text-white tablet:flex-row tablet:items-center tablet:justify-between tablet:p-12"
    >
      <div className="max-w-150">
        <h2 id="ontrack-advisor-heading" className="text-title-md text-white">
          Talk to a fiduciary advisor about what&apos;s next
        </h2>
        <p className="mt-3 text-body text-bone">
          Numbers are only part of the picture. Our financial advisors can help you weigh trade-offs, stress-test your
          plan and adjust it as your life changes.
        </p>
      </div>
      <ScheduleCallCTA
        id="ontrack-callout-cta"
        segmentElement="OnTrack Advisor Callout"
        baseUrl={unlocked ? ONTRACK_CALENDLY_HREF : undefined}
        variant="funnel"
        size="cta-sm"
        className="shrink-0"
      >
        Book an intro call
      </ScheduleCallCTA>
    </section>
  )
}
